import React, { useEffect } from "react";
import { animateScroll } from "react-scroll";
import { Link } from "gatsby";

const Header = ({ phoneNumber }) => {
  const defaultPhoneNumber = "800-789-4908";

  useEffect(() => {
    animateScroll.scrollToTop({
      duration: 400,
      smooth: true,
    });
  }, []);

  return (
    <header className="relative inset-x-0 top-0 z-50 shadow">
      <nav className="py-4" aria-label="Global">
        <div className="container flex items-center justify-between">
          <Link to="/">
            <img
              className="h-8 sm:h-10"
              src="/images/adc-white-logo.webp"
              alt="Logo"
            />
          </Link>
          <a
            className="transition text-sky-900 border-2 border-sky-900 bg-transparent hover:text-white hover:bg-sky-900 text-sm sm:text-md font-semibold px-4 py-1.5 rounded-md"
            href={`tel:${phoneNumber || defaultPhoneNumber}`}
          >
            {phoneNumber || defaultPhoneNumber}
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
